export var SparkJobStatus;
(function (SparkJobStatus) {
    SparkJobStatus["SPARK_JOB_STATUS_SUBMITTED"] = "SUBMITTED";
    SparkJobStatus["SPARK_JOB_STATUS_PENDING"] = "PENDING";
    SparkJobStatus["SPARK_JOB_STATUS_SCHEDULED"] = "SCHEDULED";
    SparkJobStatus["SPARK_JOB_STATUS_RUNNING"] = "RUNNING";
    SparkJobStatus["SPARK_JOB_STATUS_SUCCESS"] = "SUCCESS";
    SparkJobStatus["SPARK_JOB_STATUS_FAILED"] = "FAILED";
    SparkJobStatus["SPARK_JOB_STATUS_CANCELLING"] = "CANCELLING";
    SparkJobStatus["SPARK_JOB_STATUS_CANCELLED"] = "CANCELLED";
    SparkJobStatus["SPARK_JOB_STATUS_QUEUED"] = "QUEUED";
})(SparkJobStatus || (SparkJobStatus = {}));
